import writeXlsxFile from "write-excel-file/browser";
import { readSheet } from "read-excel-file/browser";

const MS_PER_DAY = 86400000;
// Days from the Excel 1900 epoch to the Unix epoch.
const EXCEL_EPOCH_OFFSET = 25569;

// write-excel-file reads a plain object as a cell object, so it becomes a string here.
// SheetJS wrote such values as text.
// write-excel-file writes a Date in UTC, but SheetJS used local time.
// The shift keeps the local date and time in the cell.
function toCell(value) {
  if (value instanceof Date) {
    return new Date(value.getTime() - value.getTimezoneOffset() * 60000);
  }
  if (value !== null && typeof value === "object") {
    return String(value);
  }
  return value;
}

// "m/d/yy" is the SheetJS default date format.
function toSheets(sheets) {
  return sheets.map(({ sheet, rows }) => ({
    sheet,
    data: rows.map((row) => Array.from(row, toCell)),
    dateFormat: "m/d/yy"
  }));
}

// sheets: [{ sheet: "Sheet1", rows: [[...], ...] }]
export function downloadXlsx(fileName, sheets) {
  return writeXlsxFile(toSheets(sheets)).toFile(fileName);
}

// Same file as downloadXlsx, as an ArrayBuffer for upload.
export function xlsxArrayBuffer(sheets) {
  return writeXlsxFile(toSheets(sheets))
    .toBlob()
    .then((blob) => blob.arrayBuffer());
}

// SheetJS gave a date cell as its Excel serial number.
// read-excel-file gives a Date in UTC, so it changes back to the serial number here.
// SheetJS gave no value for an empty cell, so it becomes "".
function fromCell(cell) {
  if (cell === null) {
    return "";
  }
  if (cell instanceof Date) {
    return cell.getTime() / MS_PER_DAY + EXCEL_EPOCH_OFFSET;
  }
  return cell;
}

// Rows of the first sheet.
export function readFirstSheet(file) {
  return readSheet(file).then((rows) => rows.map((row) => row.map(fromCell)));
}
